module.exports = __webpack_public_path__ + "2f7b605d66cb7d92d2d9cda48e12a608.jpg";